import { render, staticRenderFns } from "./enabling-datavant-tokenization-modal.vue?vue&type=template&id=0ccabcd0&"
import script from "./enabling-datavant-tokenization-modal.vue?vue&type=script&lang=js&"
export * from "./enabling-datavant-tokenization-modal.vue?vue&type=script&lang=js&"
import style0 from "./enabling-datavant-tokenization-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "enabling-datavant-tokenization-modal.vue"
export default component.exports